export const handleReactSlot = (slot, props = {}, ...restArgs) => {
  switch (typeof slot) {
    case "function":
      return slot(props, ...restArgs);
    default:
      return slot;
  }
};

export const handleReactRef = (ref, instance) => {
  if (ref) {
    if (typeof ref === "function") {
      ref(instance);
    } else if ("current" in ref) {
      ref.current = instance;
    }
  }
};
